/**
 * A school may hide a choice on one form without taking it off the question. The choice stays in
 * the form builder, so it can be shown again, and it keeps the id it already had.
 *
 * This matters most on the Admissions Categories question, where the option id is the id of the
 * category in Lookups. A tick has to land on the category it names.
 */
export const optionsShownToRecipient = (options) =>
    (options ?? []).filter(option => !option?.hidden);

export const isHiddenOnThisForm = (option) => Boolean(option?.hidden);
